module.exports = __webpack_public_path__ + "media/images/core_values/optimism-8b5ac6a9518acdccb1dff7699db33209.png";